import { SPS_PATH_PREFIX } from "./constants";

const promptPatchApiSps = (id) => {
  return `${SPS_PATH_PREFIX}/prompts/${id}/`;
};

const promptRunApiSps = `${SPS_PATH_PREFIX}/fetch/`;

const promptOutputApiSps = (toolId, promptId, docId) => {
  let url = `${SPS_PATH_PREFIX}/prompt-output/?tool_id=${toolId}`;

  if (promptId) {
    url += `&prompt_id=${promptId}`;
  }

  if (docId) {
    url += `&document_manager=${docId}`;
  }
  return url;
};

const promptReorderApiSps = `${SPS_PATH_PREFIX}/prompts/reorder/`;

const indexStatuses = {
  yet_to_start: "YET_TO_START",
  in_progress: "IN_PROGRESS",
  success: "SUCCESS",
  failed: "FAILED",
};

export {
  promptPatchApiSps,
  promptRunApiSps,
  promptOutputApiSps,
  indexStatuses,
  promptReorderApiSps,
};
